<template>
  <div class="newCon">
    <!-- 轮播图 -->
    <div class="conSwiper" style="margin-top: 45px">
      <sub-top-swiper :type="bannerType" />
    </div>
    <!-- 除轮播图以外的内容 -->
    <div style="width: 1250px; margin: 0 auto">
      <!-- 搜索 -->
      <div class="conSearch">
        <!-- 搜索框搜索 -->
        <div class="searchInp">
          <el-input placeholder="点击输入写字楼名称" v-model="houseParams.szlp">
            <el-button
              slot="append"
              icon="el-icon-search"
              style="background: #ea4736; color: #fff"
              @click="goSearch()"
            ></el-button>
          </el-input>
        </div>
        <!-- 地域搜索 -->
        <!-- <div class="region">
          <div style="margin-bottom: 20px" class="area">
            <span>区域</span>
            <span
              :class="item.isSelect ? 'isSelect' : 'unSelect'"
              v-for="item in areaList"
              :key="item.ctqybm"
              @click="handelArea(item)"
              >{{ item.ctqyname }}</span
            >
          </div>
          <div class="price">
            <span>单价</span>
            <span
              :class="item.isSelect ? 'isSelect' : 'unSelect'"
              v-for="item in priceList"
              :key="item.djid"
              @click="handelPrice(item)"
              >{{ item.dj }}</span
            >
          </div>
        </div> -->
      </div>
      <!-- 二手房列表 -->
      <div class="newList">
        <div class="footList">
          <el-empty
            description="暂无数据"
            v-if="houseList.records && houseList.records.length === 0"
          ></el-empty>
          <div class="listMain" v-else>
            <div
              class="listItem"
              v-for="item in houseList.records"
              :key="item.xzlid"
              @click="goDetail(item)"
            >
              <div class="itemLeft">
                <div class="leftImg">
                  <img :src="item.cxfmtpurl" alt="" v-if="item.cxfmtpurl" />
                  <img
                    src="https://lyimgs.oss-cn-shenzhen.aliyuncs.com/websiteImg/empty.png"
                    alt=""
                    v-else
                  />
                </div>
                <div class="rightTitle">
                  <div class="title1">
                    <span>{{ item.szlp }}</span>
                    <span v-if="item.xszt">{{ item.xszt || '暂无数据' }}</span>
                  </div>
                  <div class="title2">
                    <i class="el-icon-map-location"></i>
                    {{ item.dz || '暂无数据' }}
                  </div>
                  <div class="title2">
                    <i class="el-icon-school"></i>
                    装修情况：{{ item.zxzk || '暂无数据' }}
                  </div>
                  <div class="title2">
                    <i class="el-icon-office-building"></i>
                    <!-- <span>户型：{{ item.hxname || '暂无数据' }}</span> -->
                    <span style="margin-left: 5px"
                      >建筑面积：{{ item.jzmj || '暂无数据' }}</span
                    >
                  </div>
                  <div class="title3">
                    <span v-for="lable in item.lplabel" :key="lable">{{
                      lable
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="itemRight">
                参考均价<span style="color: #ff1b01; padding: 0 5px">{{
                  item.dj || '待定'
                }}</span>
                <span v-if="item.dj">元/平</span>
              </div>
            </div>
          </div>
          <div class="pagination">
            <el-pagination
              background
              @current-change="handleCurrentChange"
              :page-size="5"
              :hide-on-single-page="true"
              layout="prev, pager, next"
              :total="houseList.total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getOffice } from '@/api/home.js'
import SubTopSwiper from '@/components/subTopSwiper.vue' // 顶部轮播图
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'NewHouse',
  components: {
    SubTopSwiper,
  },
  data() {
    return {
      // 新房列表参数
      houseParams: {
        housePageNum: 1, // 新房列表 当前页
        ctqybm: '', // 深圳地区id
        junjmax: '', // 最高价
        junjmin: '', // 最低价
        szlp: '', // 关键字搜索
      },
      houseList: {}, // 新房列表数据
      bannerType: 'news', // banner轮播类型
    }
  },
  created() {
    // 深圳地区
    this.getAreaData({
      ctid: this.$store.state.ctid,
      pageNum: 1,
      pageSize: 100,
    })
    // 价格区间
    this.getPriceData({
      ctid: this.$store.state.ctid,
      pageNum: 1,
      pageSize: 100,
    })
    this.getHouseData()
  },
  methods: {
    ...mapMutations(['getAreaData', 'getPriceData']),
    // 搜索框搜索
    goSearch() {
      this.getHouseData()
    },
    // 清空所有搜索条件
    cleanSearch() {
      this.tags = []
      this.topKeyWord = ''
      this.houseParams.ctqybm = '' // 深圳地区id
      this.houseParams.junjmax = '' // 最高价
      this.houseParams.junjmin = '' // 最低价
      this.houseParams.housePageNum = 1
      this.$store.state.areaList.map((item) => {
        item.isSelect = false
      })
      this.$store.state.priceList.map((item) => {
        item.isSelect = false
      })
      this.$store.state.areaList[0].isSelect = true
      this.$store.state.priceList[0].isSelect = true
      this.getHouseData()
    },
    // 关闭搜索条件标签
    handleClose(info) {
      // 清空选中的状态
      if (info.type == 'area') {
        this.handelArea(this.$store.state.areaList[0])
      } else {
        this.handelPrice(this.$store.state.priceList[0])
      }
    },
    // 新房分页获取当前页
    handleCurrentChange(val) {
      this.houseParams.housePageNum = val
      // 新房列表
      this.getHouseData()
      this.$forceUpdate()
    },
    // 获取二手房列表
    async getHouseData() {
      this.houseParams.ctqybm = ''
      this.houseParams.junjmax = '' // 最高价
      this.houseParams.junjmin = '' // 最低价
      //   this.tags.forEach((item) => {
      //     if (item.type === 'area') {
      //       this.houseParams.ctqybm = item.ctqybm
      //     } else {
      //       this.houseParams.junjmax = item.djmaxvalue // 最高价
      //       this.houseParams.junjmin = item.djminvalue // 最低价
      //     }
      //   })
      await getOffice({
        pageSize: 5,
        ctid: null,
        pageNum: this.houseParams.housePageNum,
        szlp: this.houseParams.szlp
        // ctqybm: this.houseParams.ctqybm, // 深圳地区id
        // junjmax: this.houseParams.junjmax, // 最高价
        // junjmin: this.houseParams.junjmin, // 最低价
      })
        .then((res) => {
          this.houseList = res.data
          console.log(this.houseList)
          //   this.houseList.records.map(item => {
          //     if(item.lplabel === null) {
          //       item.lplabel = []
          //     } else {
          //       item.lplabel = item.lplabel.split(',')
          //       item.lplabel = item.lplabel.slice(0, 2)
          //     }
          //   })
        })
        .catch((err) => console.log(err))
        .finally(() => {})
    },
    // 选中深圳地区筛选
    handelArea(info) {
      if (info.isSelect) {
        return false
      }
      this.houseParams.housePageNum = 1
      // 重置所有
      this.$store.state.areaList.forEach((item) => (item.isSelect = false))
      // 将当前的改为选中
      info.isSelect = true

      if (info.ctqyname !== '不限') {
        if (this.tags.length > 0) {
          this.tags.forEach((item, index) => {
            if (item.type === 'area') {
              this.tags.splice(index, 1)
            }
          })
        }
        this.tags.push({ ...info, type: 'area' })
      } else {
        this.tags.forEach((item, index) => {
          if (item.type === 'area') {
            this.tags.splice(index, 1)
          }
        })
      }

      this.getHouseData()
    },
    // 选中价格筛选
    handelPrice(info) {
      if (info.isSelect) {
        return false
      }
      this.houseParams.housePageNum = 1
      // 重置所有
      this.$store.state.priceList.forEach((item) => (item.isSelect = false))
      // 将当前的改为选中
      info.isSelect = true

      if (info.dj !== '不限') {
        if (this.tags.length > 0) {
          this.tags.forEach((item, index) => {
            if (item.type === 'price') {
              this.tags.splice(index, 1)
            }
          })
        }
        this.tags.push({ ...info, type: 'price' })
      } else {
        this.tags.forEach((item, index) => {
          if (item.type === 'price') {
            this.tags.splice(index, 1)
          }
        })
      }

      this.getHouseData()
    },
    // 查看详情
    goDetail(info) {
      this.$router.push({
        name: 'OfficeDetail',
        query: { xzlid: info.xzlid },
      })
    },
  },
  computed: { ...mapState(['areaList', 'priceList', 'headKeyWord']) },
}
</script>

<style scoped lang="scss">
.newCon {
  .conSearch {
    margin: 30px 0px;
    .region {
      text-align: left;
      padding: 20px;
      box-shadow: 0px 0px 10px #e0dede;
      border-radius: 20px;
      .area {
        span:nth-child(1) {
          color: #333;
          font-size: 24px;
          margin-right: 20px;
        }
        .isSelect {
          margin: 0 15px;
          color: #ff1b01;
          font-size: 18px;
          cursor: pointer;
        }
        .unSelect {
          margin: 0 15px;
          color: #7c7c7c;
          cursor: pointer;
        }
      }
      .price {
        span:nth-child(1) {
          color: #333;
          font-size: 24px;
          margin-right: 20px;
        }
        .isSelect {
          margin: 0 15px;
          color: #ff1b01;
          font-size: 18px;
        }
        .unSelect {
          margin: 0 15px;
          color: #7c7c7c;
          cursor: pointer;
        }
      }
    }
    .searchInp {
      margin: 30px;
      :deep() {
        .el-input__inner:focus {
          border: 1px solid #ff1b01 !important;
        }
      }
    }
  }
  // 新房列表
  .newList {
    margin: 20px 0px;
    .topSearch {
      :deep() {
        .el-tabs__item.is-top.is-active {
          background-color: #f14735;
          color: #fff;
        }
        .el-tabs__item:hover {
          color: #f14735;
        }
        .el-tabs__active-bar,
        .el-tabs__nav-wrap::after {
          background-color: #f14735;
        }
        .el-tabs__item {
          padding: 0 20px !important;
        }
      }
      .searchCen {
        display: flex;
        justify-content: space-between;
        color: #333;
        font-size: 16px;
        margin: 10px 0;
        .cenTags {
        }
        .cenClear {
          cursor: pointer;
        }
      }
      .searchFoot {
        text-align: left;
        border-bottom: 2px solid #e4e7ed;
        padding: 20px 0;
        color: #333;
        font-size: 20px;
        font-weight: 600;
      }
    }
    .footList {
      .listMain {
        .listItem {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid #e4e7ed;
          padding: 15px 0;
          cursor: pointer;
          .itemLeft {
            display: flex;
            .leftImg {
              height: 200px;
              width: 270px;
              overflow: hidden;
              background-color: #fff;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .rightTitle {
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              padding: 15px 30px;
              text-align: left;
              .title1 {
                display: flex;
                align-items: center;
                span:nth-child(1) {
                  color: #333;
                  font-size: 22px;
                  font-weight: 600;
                  margin-right: 20px;
                }
                span:nth-child(2) {
                  color: #ff1b01;
                  font-size: 14px;
                  border: 1px solid #ff1b01;
                  border-radius: 3px;
                  padding: 1px 5px;
                }
              }
              .title2 {
                color: #676767;
                font-size: 16px;
              }
              .title3 {
                span {
                  background-color: #b1c0ad;
                  font-size: 16px;
                  color: #333;
                  padding: 2px 8px;
                  border-radius: 3px;
                  margin-right: 10px;
                }
              }
            }
          }
          .itemRight {
            color: #676767;
            font-size: 16px;
          }
        }
      }
      .pagination {
        margin-top: 30px;
        :deep() {
          .number.active {
            background-color: #f24736 !important;
          }
          .number:hover {
            color: #606266;
          }
        }
      }
    }
  }
}
</style>
